
import React from 'react';
import { content } from '../data/content';

interface FooterProps {
  onContactClick: () => void;
}

const Footer: React.FC<FooterProps> = ({ onContactClick }) => {
  const { footer } = content;

  return (
    <footer className="bg-gray-900 text-white py-12 border-t border-gray-800">
      <div className="container mx-auto px-6">
        <div className="flex flex-col gap-8">
          
          {/* Centered Navigation Links */}
          <div className="flex justify-center">
            <div className="flex flex-wrap justify-center gap-8 md:gap-12">
              {footer.links?.map((link, index) => (
                <a 
                  key={index} 
                  href={link.href}
                  onClick={(e) => {
                    if (link.href === '#contact') {
                      e.preventDefault();
                      onContactClick();
                    }
                  }}
                  className="text-gray-400 hover:text-white transition-colors text-sm font-medium cursor-pointer"
                >
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          {/* Logo & Copyright - Bottom */}
          <div className="text-center border-t border-gray-800 pt-8">
            <div className="text-2xl font-bold tracking-tight font-sans text-white mb-2">
              Omnisonic <span className="text-primary-500">AI</span>
            </div>
            <p className="text-gray-400 text-sm">
              {footer.copyright}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
